import React, { useMemo,useState } from "react";
import AddCastingModal from "./AddCastingModal";

const MIVTable = ({ reportData, totalcount, data, loginUser}) => {
    const [selectedItem, setSelectedItem] = useState();
    const [gridInsideModal, setGridInsideModal] = useState(false);
    const [test, setTest] = useState(0);
  // Extract document data once to avoid multiple optional chaining calls
  const { mivNo = "N/A", store = "N/A", createdAt = "", status = "N/A", user = "N/A", updatedAt = "" } = data?.document || {};
  const formattedCreatedAt = createdAt ? createdAt.split("T")[0] : "N/A";
  const formattedUpdatedAt = updatedAt ? updatedAt.split("T")[0] : "N/A";
  const { storeName} = data?.document || {};
  const handleCasting = (item) => {
    setSelectedItem(item); // Set the item to be edited
    setGridInsideModal(true); // Show modal
  };
  return (
    <>
    <AddCastingModal
            item={selectedItem}
            show={gridInsideModal}
            test={setTest}
            storeName={store}
            RequestNo={mivNo}
            data={data}
            RequestType="MIV"
            loginUser={loginUser?.data?.user?._id}
            handleClose={() => setGridInsideModal(false)}
          />
    <div className="filter cm-content-box box-primary">
      <div className="content-title d-flex justify-content-between align-items-center">
        <div className="cpa">
          <i className="fa fa-list me-2"></i>MIV Items
          <span className="badge bg-orange ms-2">{totalcount}</span>
        </div>
        <div className="d-flex align-items-center">
          
        </div>
      </div>
      <div className="cm-content-body form excerpt">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>MIV No</th>
                  <th>Store</th>
                  <th>Date</th>
                  <th>Part No</th>
                  <th>Description</th>
                  <th>Unit</th>
                  <th>Approved Qty</th>
                  <th>Used Qty</th>
                  <th>Status</th>
                  <th>Store Keeper</th>
                  <th>Updated Date</th>
                  <th>Generate Casting</th>
                </tr>
              </thead>
              <tbody>
                {reportData.length > 0 ? (
                  reportData.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{mivNo}</td>
                      <td>{store}</td>
                      <td>{formattedCreatedAt}</td>
                      <td>{item?.partNo || "N/A"}</td>
                      <td className="scrollable-description">{item?.description || "N/A"}</td>
                      <td>{item?.unitName || "N/A"}</td>
                      <td>{item?.approveQty || "N/A"}</td>
                      <td>{item?.usedQty || "N/A"}</td>
                      <td>{status}</td>
                      <td>{user}</td>
                      <td>{formattedUpdatedAt}</td>
                      <td className="text-center">
                                  <button
                                    className="btn btn-primary btn-xs sharp"
                                    onClick={() => handleCasting(item)} // Open modal on edit click
                                  >
                                    <i className="fa fa-pencil"></i>
                                  </button>
                                </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="12" className="text-center">
                      No data available.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default React.memo(MIVTable);
